/**
 * Parse a synthetic recurring-event id of the form `${uuid}_${iso}`.
 *
 * Returns `{ baseId, occurrenceIso }` for valid synthetic ids — `null` otherwise.
 *
 * The strict UUID-anchored regex (RESEARCH.md Pitfall 5) prevents free-text
 * payloads from masquerading as synthetic ids in PHI-safe analytics logging
 * (T-36-SYNTHETIC-ID-LEAK). UUID + ISO timestamp are both PHI-safe — never log
 * the raw recurring `event.id` directly.
 */
// Anchored to end-of-string and the timestamp suffix is constrained to a real
// ISO-8601 shape: required `YYYY-MM-DDTHH:mm:ss`, optional fractional seconds
// (1–3 digits), optional `Z` or `±HH:MM` offset. Anything beyond is rejected
// (e.g. `${uuid}_${iso}__anything` no longer parses as synthetic).
const SYNTHETIC_ID_RE =
	/^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})_(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})?)$/;

export function parseSyntheticEventId(
	id: string,
): { baseId: string; occurrenceIso: string } | null {
	const m = SYNTHETIC_ID_RE.exec(id);
	return m ? { baseId: m[1], occurrenceIso: m[2] } : null;
}
